import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { initSentry } from './app/core/services/sentry.service';

import { AppModule } from './app/app.module';

initSentry();

platformBrowserDynamic().bootstrapModule(AppModule, {
  ngZoneEventCoalescing: true
})
  .catch(err => console.error(err));
